import { Button } from '@graftcode/design-system'

import { MOBILE_MENU_TEST_IDS } from '@common/common-test-ids.const'
import styles from '@common/components/MobileMenu/MobileMenu.module.scss'

import { ACADEMY_NAV_SECTIONS, IS_CODE_SANDBOX_ENABLED } from '../../academy-mobile-menu.const'
import type { MobileNavigationState } from '../../hooks/useMobileNavigation'
import type { TutorialSection } from '../../types'

import { DocumentationGroup } from './DocumentationGroup'
import { QuickStartGroup } from './QuickStartGroup'

type HomeNavItemsProps = {
  nav: MobileNavigationState
  onNavigationClick: (url: string) => void
  tutorialSections: TutorialSection[]
  currentTutorialPath?: string
  expandedCategories: Set<string>
  onToggleCategory: (categoryPath: string) => void
}

export function HomeNavItems({
  nav,
  onNavigationClick,
  tutorialSections,
  currentTutorialPath,
  expandedCategories,
  onToggleCategory,
}: HomeNavItemsProps) {
  return (
    <div data-testid={MOBILE_MENU_TEST_IDS.academyHomeNavItems} style={{ display: 'contents' }}>
      {ACADEMY_NAV_SECTIONS.filter((section) => section.items.some((item) => item.id !== 'home')).map((section) => {
        const visibleItems = nav.isSubpage
          ? section.items.filter((item) => item.id === 'quickStart' || item.id === 'documentation')
          : section.items

        if (visibleItems.length === 0) {
          return null
        }

        return (
          <div key={section.label ?? 'default'}>
            {section.label && !nav.isSubpage && (
              <div className={styles.academySectionHeader}>
                <span className={styles.academySectionHeaderLabel}>{section.label}</span>
              </div>
            )}
            {visibleItems.map((item) => {
              if (item.id === 'quickStart') {
                return (
                  <QuickStartGroup
                    key={item.id}
                    nav={nav}
                    tutorialSections={tutorialSections}
                    currentTutorialPath={currentTutorialPath}
                  />
                )
              }

              if (item.id === 'documentation') {
                return (
                  <DocumentationGroup
                    key={item.id}
                    nav={nav}
                    currentTutorialPath={currentTutorialPath}
                    expandedCategories={expandedCategories}
                    onToggleCategory={onToggleCategory}
                  />
                )
              }

              if (item.id === 'codeSandbox') {
                if (!IS_CODE_SANDBOX_ENABLED) {
                  return (
                    <Button
                      key={item.id}
                      type="button"
                      variant="ghost"
                      size="l"
                      fullWidth
                      disabled
                      icon={item.icon}
                      text={item.label}
                      className={styles.academyMainNavItem}
                    />
                  )
                }

                return (
                  <Button
                    key={item.path}
                    type="button"
                    variant="ghost"
                    size="l"
                    fullWidth
                    icon={item.icon}
                    text={item.label}
                    onClick={() => onNavigationClick(item.path)}
                    className={styles.academyMainNavItem}
                  />
                )
              }

              return (
                <Button
                  key={item.path}
                  type="button"
                  variant="ghost"
                  size="l"
                  fullWidth
                  icon={item.icon}
                  text={item.label}
                  onClick={() => onNavigationClick(item.path)}
                  className={styles.academyMainNavItem}
                />
              )
            })}
          </div>
        )
      })}
    </div>
  )
}
